import { render, staticRenderFns } from "./LeadSource.vue?vue&type=template&id=5e4dc9dc&scoped=true&"
import script from "./LeadSource.vue?vue&type=script&lang=js&"
export * from "./LeadSource.vue?vue&type=script&lang=js&"
import style0 from "./LeadSource.vue?vue&type=style&index=0&id=5e4dc9dc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4dc9dc",
  null
  
)

export default component.exports